var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c(
        "a-card",
        {
          staticStyle: {
            "box-sizing": "border-box",
            "border-radius": "0 !important",
          },
        },
        [
          !_vm.appId
            ? _c("a-divider", [_vm._v("请选择应用APPID")])
            : _vm.noConfigText
            ? _c("a-divider", [_vm._v("您尚未配置任何支付方式")])
            : _vm._e(),
          _vm.payTestShow()
            ? _c(
                "div",
                { staticClass: "paydemo", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "paydemo-type-content" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTitle("WX"),
                              expression: "showTitle('WX')",
                            },
                          ],
                          staticClass: "paydemo-type-name article-title",
                        },
                        [_vm._v(" 微信支付 ")]
                      ),
                      _c("div", { staticClass: "paydemo-type-body" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.appPaywayList.indexOf("WX_NATIVE") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_NATIVE') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type color-change",
                            class: { this: _vm.currentWayCode === "WX_NATIVE" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode(
                                  "WX_NATIVE",
                                  "codeImgUrl"
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_native.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("微信二维码"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.appPaywayList.indexOf("WX_BAR") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_BAR') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type color-change",
                            class: { this: _vm.currentWayCode === "WX_BAR" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode("WX_BAR", "")
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_bar.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("微信条码"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.appPaywayList.indexOf("WX_JSAPI") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_JSAPI') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type color-change",
                            class: { this: _vm.currentWayCode === "WX_JSAPI" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode(
                                  "WX_JSAPI",
                                  "codeImgUrl"
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_jsapi.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("公众号/小程序"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.appPaywayList.indexOf("WX_H5") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_H5') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type-h5",
                            class: { this: _vm.currentWayCode === "WX_H5" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode(
                                  "WX_H5",
                                  "payurl"
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_h5.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("微信H5"),
                            ]),
                          ]
                        ),
                      ]),
                      _c("Header"),
                      _c("div", [
                        _c("img", {
                          staticClass: "jianceimg",
                          attrs: { src: _vm.jianceimg },
                        }),
                      ]),
                      _c("div", { staticStyle: { height: "160px" } }),
                      _c(
                        "a-row",
                        [
                          _c("a-col", { attrs: { span: 1 } }, [
                            _c("div", {
                              staticStyle: { width: "100%", height: "1px" },
                            }),
                          ]),
                          _c(
                            "a-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "a-form",
                                {
                                  attrs: {
                                    form: _vm.form,
                                    "label-col": { span: 5 },
                                    "wrapper-col": { span: 18 },
                                  },
                                  on: { submit: _vm.handleSubmit },
                                },
                                [
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买项目" } },
                                    [
                                      _vm.configdata.saletype == "single"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "line-height": "40px",
                                              },
                                            },
                                            _vm._l(
                                              _vm.pricelist,
                                              function (item) {
                                                return _c(
                                                  "a-tooltip",
                                                  {
                                                    key: item.id,
                                                    attrs: { placement: "top" },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.tooltip)
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    item.checktype == "radio"
                                                      ? _c(
                                                          "el-radio-group",
                                                          {
                                                            staticStyle: {
                                                              "margin-top":
                                                                "-3px !important",
                                                            },
                                                            attrs: {
                                                              name: "radioGroup",
                                                              "default-value":
                                                                item.isforce ==
                                                                0
                                                                  ? 0
                                                                  : 1,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-radio",
                                                              {
                                                                staticStyle: {
                                                                  "margin-right":
                                                                    "15px",
                                                                },
                                                                attrs: {
                                                                  value: 1,
                                                                  border: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.title
                                                                    )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "red",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "￥" +
                                                                        _vm._s(
                                                                          item.price
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    item.marketprice >
                                                                    0
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "#999",
                                                                                "text-decoration":
                                                                                  "line-through",
                                                                                "font-size":
                                                                                  "8px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "（原价" +
                                                                                _vm._s(
                                                                                  item.marketprice
                                                                                ) +
                                                                                "）"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    item.checktype ==
                                                      "checkbox" &&
                                                    item.servicename ==
                                                      "express"
                                                      ? _c(
                                                          "el-checkbox",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "0 !important",
                                                            },
                                                            attrs: {
                                                              border: "",
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.onChange1,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.checkeddef,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.checkeddef =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "checkeddef",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.title)
                                                            ),
                                                            item.price > 0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "red",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "￥" +
                                                                        _vm._s(
                                                                          item.price
                                                                        )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    item.checktype ==
                                                      "checkbox" &&
                                                    item.servicename == "info"
                                                      ? _c(
                                                          "el-checkbox",
                                                          {
                                                            attrs: {
                                                              border: "",
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.onChange2,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.checkedtrue,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.checkedtrue =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "checkedtrue",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.title)
                                                            ),
                                                            item.price > 0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "red",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "￥" +
                                                                        _vm._s(
                                                                          item.price
                                                                        )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.configdata.saletype == "package"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  model: {
                                                    value: _vm.packageid,
                                                    callback: function ($$v) {
                                                      _vm.packageid = $$v
                                                    },
                                                    expression: "packageid",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.pricelist,
                                                  function (item) {
                                                    return _c(
                                                      "el-radio",
                                                      {
                                                        key: item.id,
                                                        staticStyle: {
                                                          "margin-left": "0",
                                                          "margin-bottom":
                                                            "5px",
                                                        },
                                                        attrs: {
                                                          label: item.id,
                                                          border: "",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.title) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "i",
                                                            {
                                                              staticStyle: {
                                                                color: "red",
                                                                "font-style":
                                                                  "italic",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "￥" +
                                                                  _vm._s(
                                                                    item.price
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          item.marketprice > 0
                                                            ? _c(
                                                                "i",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#999",
                                                                    "text-decoration":
                                                                      "line-through",
                                                                    "font-size":
                                                                      "8px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "（原价" +
                                                                      _vm._s(
                                                                        item.marketprice
                                                                      ) +
                                                                      "）"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "i",
                                                            {
                                                              staticStyle: {
                                                                color: "#999",
                                                                "font-size":
                                                                  "12px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "（" +
                                                                  _vm._s(
                                                                    item.description
                                                                  ) +
                                                                  "）"
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买数量" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "custom-input-color",
                                        attrs: {
                                          min: 1,
                                          max: 10,
                                          label: "描述文字",
                                        },
                                        model: {
                                          value: _vm.totalnum,
                                          callback: function ($$v) {
                                            _vm.totalnum = $$v
                                          },
                                          expression: "totalnum",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买单位" } },
                                    [
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "company",
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: "请输入购买单位!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "[ 'company', { rules: [ { required: true, message: '请输入购买单位!' }, ], }, ]",
                                          },
                                        ],
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入购买单位全称",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "信用代码" } },
                                    [
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "yscode",
                                              _vm.validatorRules.yscode,
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message:
                                                      "请输入统一社会信用代码!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "[ 'yscode', validatorRules.yscode, { rules: [ { required: true, message: '请输入统一社会信用代码!',},],},]",
                                          },
                                        ],
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入统一社会信用代码",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { span: 1 } }, [
                            _c("div", {
                              staticStyle: { width: "100%", height: "1px" },
                            }),
                          ]),
                          _c("a-col", { attrs: { span: 11 } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "a-form",
                                  {
                                    attrs: {
                                      form: _vm.form,
                                      "label-col": { span: 5 },
                                      "wrapper-col": { span: 18 },
                                    },
                                  },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10rpx",
                                          width: "100%",
                                        },
                                        attrs: { label: "经办人" },
                                      },
                                      [
                                        _c("a-input", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "name",
                                                {
                                                  rules: [
                                                    {
                                                      required: true,
                                                      message: "请输入经办人!",
                                                    },
                                                  ],
                                                },
                                              ],
                                              expression:
                                                "[ 'name', { rules: [ { required: true, message: '请输入经办人!' }, ], }, ]",
                                            },
                                          ],
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder: "请输入经办人姓名",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-item",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10rpx",
                                          width: "100%",
                                        },
                                        attrs: { label: "手机号码" },
                                      },
                                      [
                                        _c("a-input", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "phone",
                                                _vm.validatorRules.phone,
                                                {
                                                  rules: [
                                                    {
                                                      required: true,
                                                      message:
                                                        "请输入手机号码!",
                                                    },
                                                  ],
                                                },
                                              ],
                                              expression:
                                                "[ 'phone', validatorRules.phone,  { rules: [ { required: true, message: '请输入手机号码!' }, ], }, ]",
                                            },
                                          ],
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder: "请输入11位手机号码",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-item",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { label: "电子邮箱" },
                                      },
                                      [
                                        _c("a-input", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "email",
                                                _vm.validatorRules.email,
                                              ],
                                              expression:
                                                "['email', validatorRules.email]",
                                            },
                                          ],
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder:
                                              "请输入用于接收电子发票有效邮箱，请使用网易或QQ邮箱",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "关于发票" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              cursor: "pointer",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "发票将在订单支付成功后3-5个工作日内发送到您填写的电子邮箱内。"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticStyle: { "margin-top": "35px" } },
                        [
                          _c("a-col", { attrs: { span: 24 } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "500px",
                                  margin: "auto",
                                  "text-align": "center",
                                },
                              },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c("a-checkbox", {
                                      staticStyle: { "margin-right": "10px" },
                                      on: { change: _vm.onChangeqw },
                                      model: {
                                        value: _vm.checked,
                                        callback: function ($$v) {
                                          _vm.checked = $$v
                                        },
                                        expression: "checked",
                                      },
                                    }),
                                    _vm._v(" 我已阅读并同意 "),
                                    _c(
                                      "span",
                                      {
                                        style: _vm.radioStyle,
                                        on: { click: _vm.boglook },
                                      },
                                      [_vm._v("服务协议")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                          },
                        },
                        [
                          _vm.companyinfostatus
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    width: "200px",
                                    height: "40px",
                                    "font-size": "15px",
                                  },
                                  attrs: { type: "danger" },
                                  on: { click: _vm.login },
                                },
                                [_vm._v("登录后提交订单")]
                              )
                            : _vm._e(),
                          !_vm.companyinfostatus
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    width: "200px",
                                    height: "40px",
                                    "font-size": "15px",
                                  },
                                  attrs: {
                                    disabled: _vm.disabledlook,
                                    type: "danger",
                                  },
                                  on: { click: _vm.handleSubmit },
                                },
                                [_vm._v(" 提交订单 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                            color: "#132b75",
                            "line-height": "50px",
                            cursor: "pointer",
                          },
                          on: { click: _vm.homepay },
                        },
                        [_vm._v("返回首页")]
                      ),
                      _c("div", {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          "align-items": "center",
                          "justify-content": "center",
                        },
                        attrs: { id: "bottomtoolbar" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            "confirm-loading": _vm.confirmLoading,
            destroyOnClose: true,
            maskClosable: false,
            visible: _vm.visible,
            title: "阅读条款",
            width: "45%",
          },
          on: { cancel: _vm.handleCancel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: { click: _vm.handleOk },
                    },
                    [_vm._v(_vm._s(_vm.valiBtn))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("Contract", { attrs: { Fathertoson: _vm.Fathertoson } })],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "流程说明", width: "40%" },
          on: { ok: _vm.handleOkmodd },
          model: {
            value: _vm.visiblemodd,
            callback: function ($$v) {
              _vm.visiblemodd = $$v
            },
            expression: "visiblemodd",
          },
        },
        [
          _c("p", [
            _c("b", [
              _vm._v(
                "灌装流程说明：企业在此下单后，请再自行前往证书运维管理平台上提交证书申请。"
              ),
            ]),
          ]),
          _c("p", [_vm._v("Some contents...")]),
          _c("p", [_vm._v("Some contents...")]),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "系统提示" },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "margin-right": "15px",
                        background: "#eeeeee",
                        color: "#ffffff",
                        border: "0px",
                      },
                      on: { click: _vm.handleCanceslgiveup },
                    },
                    [_vm._v("放弃订购 ")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCanceslcontinue },
                    },
                    [_vm._v("继续订购 ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.Tips,
            callback: function ($$v) {
              _vm.Tips = $$v
            },
            expression: "Tips",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "block",
                color: "#f00",
                "font-weight": "bold",
                "font-size": "14px",
                "line-height": "50px",
                padding: "15px 0",
              },
            },
            [
              _vm._v(
                " 省心服务可以让您以最快的速度获得CA证书，确认要放弃订购吗？ "
              ),
            ]
          ),
        ]
      ),
      _c("pay-test-modal", {
        ref: "payTestModal",
        on: {
          goseal: _vm.goseal,
          closeBarCode: function ($event) {
            _vm.$refs.payTestBarCode.visible = false
          },
        },
      }),
      _c("pay-test-bar-code", {
        ref: "payTestBarCode",
        on: {
          CodeAgainChange: _vm.testCodeChange,
          barCodeValue: _vm.barCodeChange,
        },
      }),
      _vm.sssvisiblesssold
        ? _c("div", { staticClass: "positions" }, [
            _c("div", { staticClass: "position_cont" }, [
              _c("div", { staticClass: "position_conttit" }, [
                _vm._v("尊敬的用户: "),
              ]),
              _c("div", { staticClass: "position_content" }, [
                _c("div", { staticStyle: { height: "30px" } }),
                _c("p", { staticStyle: { "text-indent": "2em" } }, [
                  _vm._v(
                    "感谢您使用数字证书订购系统。购买完成后，须自行登录" +
                      _vm._s(_vm.configdata.certplatformtitle) +
                      " "
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        display: "inline-block",
                        color: "red",
                        "text-indent": "0em",
                        "font-weight": "bold",
                        margin: "0 10px",
                      },
                      attrs: {
                        href: _vm.configdata.certplatformurl,
                        target: "_blank",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.configdata.certplatformurl))]
                  ),
                  _vm._v(" 提交证书申请。 "),
                ]),
                _c("div", { staticStyle: { height: "30px" } }),
              ]),
              _c("div", { staticClass: "position_contbot" }, [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.handleCancesl },
                  },
                  [_vm._v(" 确认 ")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }